import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import useDeepLinkInitializer from '../hooks/useDeepLinkInitializer';
import type { DeepLinkInitializerProps } from '../hooks/deepLinkTypes';

const DeepLinkInitializer = ({
  targetStep,
  onComplete,
  onReset,
  onStatusChange,
}: DeepLinkInitializerProps) => {
  const { anyFailed, failedStepMessages, handleStartFromBeginning } =
    useDeepLinkInitializer({
      targetStep,
      onComplete,
      onReset,
      onStatusChange,
    });

  if (anyFailed) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            width: '100%',
            maxWidth: 600,
            textAlign: 'center',
          }}
        >
          {failedStepMessages.map(({ label, text }) => (
            <Typography
              key={label}
              color="error.main"
              variant="body1"
              sx={{ lineHeight: 3 / 2 }}
            >
              {text}
            </Typography>
          ))}
          <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={handleStartFromBeginning}
          >
            Start from beginning
          </Button>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default DeepLinkInitializer;
